import View from "./View";
import icons from "url:../../img/icons.svg";
import previewView from "./previewView";

// this class is an instance of View, which contains its own members
class ResultsView extends View {
  _parentElement = document.querySelector(".results");
  _errorMessage = "No recipes found. Please try again.";
  _message = "";
  //this function returns a string from a joined array.
  _generateMarkup() {
    return this._data
      .map((result) => previewView.render(result, false))
      .join("");
  }
}
export default new ResultsView(); // exporting instance of resultsView so that no more instances of this instance can be created
